export default "__VITE_ASSET__Jm5CrXkg__"